import styled from "styled-components";
import background from "../../../helpers/background";
import color from "../../../helpers/color";
import overflow from "../../../helpers/overflow";
const Panel = /*#__PURE__*/styled.div.withConfig({
  displayName: "Panel",
  componentId: "sc-1rjmjms-0"
})(["", " ", ";display:flex;flex-direction:column;border:2px solid ", ";& + &{margin-top:1vh;}"], overflow, background, color);
Panel.defaultProps = {
  color: "divider",
  background: "primary"
};
Panel.displayName = "Panel";
export default Panel;
//# sourceMappingURL=index.js.map